import axios from 'axios';
import getApiBaseUrl from '../GetServer';

interface ChangeStatusPayload {
    idClient: number;
    status: number;
}

export const changeClientStatus = async (payload: ChangeStatusPayload) => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/change-status-client`;
        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('Token no disponible');
        }

        // Adaptamos el payload para que coincida con lo que espera el backend (idUser)
        const backendPayload = {
            idUser: payload.idClient,
            status: payload.status,
        };

        const response = await axios.post(endpoint, backendPayload, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Error al cambiar el estado del cliente';
        console.error('Error en changeClientStatus:', errorMessage, error);
        throw new Error(errorMessage);
    }
};
